export default __webpack_public_path__ + "static/media/sphere.d09386d6.png";